export default {
  size: 1
}
